import { cx } from "react-emotion";
import { observer } from "mobx-react";
import React from "react";
import shortid from "shortid";
import SvgIcon from "components/SvgIcon";
import { t } from "translations/i18n";

import checkboxIcon from "./checkbox.svg";

function InputCheckbox(props) {
  const {
    id = shortid.generate(),
    label,
    name,
    style = {},
    labelWidth = "",
    inputWidth = "",
    store,
    value = null,
    // icon,
    onChange,
    disabled,
    selectionTheme = "normal",
    iconVisibleMobile = false,
    iconVisible = true,
    labelColoring = true,
    labelCheckedClass,
    labelDisabledClass,
    iconFirst = true,
    valueDefault = false,
    type = "checkbox",
    textLeft,
    noCheckboxClass = false,
  } = props;

  const typeYesNo = type === "yesno";

  const checked = store
    ? name.slice(-2) === "[]"
      ? (store.get(name.replace("[]", "")) || []).includes(value)
      : typeof store.get(name) !== "undefined"
      ? store.get(name)
      : valueDefault
    : value === "notSelected"
    ? null
    : value;

  // const checked = typeof storeValue !== 'undefined' || valueDefault
  // : value;

  const iconEl = iconVisible ? (
    <label
      className={["control-label", "iconx", iconVisibleMobile ? "" : "hidden-xs", inputWidth].join(" ")}
      htmlFor={id}
    >
      <SvgIcon src={checkboxIcon} className={"icon"} />
    </label>
  ) : null;

  return (
    <div
      data={store && store.data}
      style={style}
      className={[
        !noCheckboxClass ? "checkbox" : "",
        disabled ? "disabled" : "",
        "iconx",
        iconFirst ? "iconFirst" : "",
        checked ? "selected" : "",
      ].join(" ")}
    >
      {!typeYesNo && iconFirst && iconEl}
      {label && (
        <label
          htmlFor={id}
          className={[
            "control-label",
            "label-text",
            textLeft && "text-left",
            labelCheckedClass && checked && labelCheckedClass,
            labelDisabledClass && disabled && labelDisabledClass,
            selectionTheme,
            labelWidth,
            labelColoring && "labelColoring",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {label || name}
        </label>
      )}
      <div className={inputWidth}>
        {!typeYesNo && !iconFirst && iconEl}
        {typeYesNo && (
          <span className={"typeYesNo"}>
            <span onClick={() => store.set(name, true)} className={checked && checked !== "notSelected" && "selected"}>
              {t("home:yes")}
            </span>
            <span onClick={() => store.set(name, false)} className={checked === false && "selected"}>
              {t("home:no")}
            </span>
          </span>
        )}
        <input
          id={id}
          className="control-label hidden"
          name={name}
          onChange={!disabled ? onChange : undefined}
          type="checkbox"
          value={value || ""}
          checked={checked}
        />
      </div>
    </div>
  );
}

export default observer(InputCheckbox);
